import styled from "@emotion/styled"

export const ArticleContainer = styled.article`
  max-width: 800px;
  width: 100%;
  margin: 2rem 1rem;
`

export const Main = styled.main`
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 1rem;
  width: 100%;
  height: 100%;
`
